import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import Filter from 'views/messages/popup/filter'; // Importing Filter component
import Table from 'views/messages/popup/table'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

export default class popupView extends JetView {
    /**
     * Configures the UI components of the popup view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const toolbar = {
            view: 'toolbar', // Toolbar component
            id: 'toolbar', // Unique identifier for the toolbar
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5, // Horizontal padding
            paddingY: 5, // Vertical padding
            height: 40, // Height of the toolbar
            cols: [
                // Columns within the toolbar
                {
                    view: 'select', // Dropdown for selecting page size
                    options: ['10', '20', '50', '100'], // Options for page size
                    width: 70, // Width of the dropdown
                    on: {
                        onChange: function () {
                            // Event handler for change event
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh the datatable
                            $$('datatable').scrollTo(100, 0); // Scroll to the top
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Template for pager buttons
                    autosize: false, // Disable autosizing
                    height: 35, // Height of the pager
                    size: devConfig.getDefaultDataFetch(), // Default page size from configuration
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export', // Name of the export field
                    id: 'Export', // Unique identifier for the export dropdown
                    width: 120, // Width of the dropdown
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        // Options for export format
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export format change
                            if (value == 1) {
                                // If Excel is selected
                                var table = $$('datatable'); // Reference to the datatable
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    // Loop through columns
                                    if (table.config.columns[j].exportType) {
                                        // Check for export type
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Popup'), // Filename for the export
                                    ignore: {
                                        // Fields to ignore during export
                                        Action: true,
                                        detailTittle: true,
                                        ActionTittle: true,
                                    },
                                });
                            } else if (value == 2) {
                                // If PDF is selected
                                webix.toPDF($$('datatable'), {
                                    // Export to PDF
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Popup'), // Filename for the export
                                    autowidth: true, // Enable auto width for PDF
                                    ignore: {
                                        // Fields to ignore during export
                                        Action: true,
                                        detailTittle: true,
                                        ActionTittle: true,
                                    },
                                });
                            }
                            $$('Export').setValue(''); // Reset export selection
                        },
                    },
                },
            ],
        };
        const left = {
            rows: [
                // Layout for the left side
                Filter, // Filter component
                { id: 'res', view: 'resizer' }, // Resizer for layout adjustment
                Table, // Table component
                toolbar, // Toolbar component
            ],
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            id: 'a5', // Unique identifier for the form
            type: 'clean', // Type of the view
            view: 'form', // Form view
            scroll: 'y', // Enable vertical scrolling
            rows: [
                // Rows in the form
                {
                    responsive: 'a5', // Responsive design identifier
                    type: 'wide', // Type of layout
                    cols: [left], // Columns in the layout
                },
            ],
        };
    }

    /**
     * Initializes the popup view and sets up event handlers.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            // Wait for Webix to be ready
            if (screen.width < 500) {
                // Check for small screen size
                $$('res').hide(); // Hide the resizer
                var childs = $$('toolbar').getChildViews(); // Get child views of the toolbar
                $$('toolbar').removeView(childs[2]); // Remove the third child view (export dropdown)
                $$('pagerA').define('group', 1); // Define pager grouping
            }
            $.fn.scrollBottom = function () {
                // jQuery function to calculate scroll bottom
                return $(document).height() - this.scrollTop() - this.height(); // Return scroll bottom value
            };
        });
    }
}

// FILE DOCUMENTED
